<template>
  <section>
    <b-button @click="toggleOn" v-bind="context.attrs">Settings</b-button>
    <b-modal :active.sync="isModalActive" has-modal-card trap-focus>
      <ui-settings />
    </b-modal>
  </section>
</template>

<script>
import { ref } from "@vue/composition-api";
import UiSettings from "@/components/UiSettings";

export default {
  name: "SettingsButton",
  components: { UiSettings },
  setup(props, context) {
    const isModalActive = ref(false);
    const toggleOn = () => {
      isModalActive.value = true;
    };

    return {
      isModalActive,
      toggleOn,
      context: context
    };
  }
};
</script>
